import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Icon } from '@iconify/react';
import './Jobs.css';

const Jobs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Posts');
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

 useEffect(() => {
  const timer = setTimeout(() => {
    setIsLoading(false);

    // Show popup automatically after loading
    setPopupMessage(
      "Jobs are currently unavailable, please access them on the website spcommunity.org.za/job-posts"
    );
    setShowPopup(true);
  }, 1000);

  return () => clearTimeout(timer);
}, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const NaviconStyle = {
    marginRight: '10px',
    marginTop: '10px',
    marginLeft: '10px',
  };

  // Map tabs to iframe sources
  const tabSources = {
 
  Posts: 'https://www.spcommunity.org.za/jobs/',
    'My Jobs': 'https://www.spcommunity.org.za/user-jobs/',
    Inbox: 'https://www.spcommunity.org.za/user-messages/',
    Profile: 'https://www.spcommunity.org.za/user-profile/',
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
  

    <div className="jobs-container">
      {/* Top Nav Menu */}

      <div className="top-nav">
        {Object.keys(tabSources).map((tab) => (
          <button
            key={tab}
            className="nav-tab"
            onClick={() => {
              setPopupMessage("Jobs are currently unavailable, please access them on the website spcommunity.org.za/job-posts");
              setShowPopup(true);
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      
      {showPopup && (
    <div className="custom-popup">
      <div className="popup-content">
        <p>{popupMessage}</p>
        <button onClick={() => setShowPopup(false)}>OK</button>
      </div>
    </div>
  )}

       
    </div>




/*
    <div className="jobs-container">
      
     
    */
  );
};

export default Jobs;






/*
const ContactForm = () => {
    return (
      <iframe
        src="https://jobs.spcommunity.org.za"
       style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
        title="Contact Form"
      ></iframe>
    );
  };
  
  export default ContactForm; */

  

  /*


  */



  /*
<div className="top-nav">
        {Object.keys(tabSources).map((tab) => (
          <button
            key={tab}
            className={`nav-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
        
      </div>
     
      <iframe
        src={tabSources[activeTab]}
        style={{ width: '100%', height: '100vh', border: 'none', overflow: 'auto' }}
        title={activeTab}
        onLoad={() => setIsLoading(false)}
      ></iframe>

  */